import { render, staticRenderFns } from "./ChampTable.vue?vue&type=template&id=5599e38a&"
import script from "./ChampTable.vue?vue&type=script&lang=ts&"
export * from "./ChampTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ChampTable.vue"
export default component.exports